

export const GREENERGENIC_CONFIG = {
//  HOSTNAME : 'http://localhost:3002', //for develop
   HOSTNAME : 'http://210.101.202.92:3002', //for develop
  // HOSTNAME : 'http://3.36.30.180:3002', //for release
  // WEBSOCKET_URL : 'ws://localhost:3003/',

  ERROR_BACKEND: 'http://15.164.70.192:3003', //error reporter backend

  // AUTH_TYPE_ADMIN : 1,
  // AUTH_TYPE_MEMBER : 2,
};

